import React from "react";
import PropTypes from "prop-types";

import { Money, pluralize } from "..";

function UnitPrice({ currency, unitPrice, planMultiple, unitText }) {
  return (
    <div>
      <div>
        <Money currency={currency}>{unitPrice}</Money>
      </div>
      <i>{` per ${planMultiple === 1 ? "" : `${planMultiple} `}${pluralize(
        unitText,
        planMultiple
      )}`}</i>
    </div>
  );
}

UnitPrice.propTypes = {
  currency: PropTypes.string,
  unitPrice: PropTypes.string.isRequired,
  planMultiple: PropTypes.number,
  unitText: PropTypes.string,
};

UnitPrice.defaultProps = { planMultiple: 1, unitText: "seat", currency: "USD" };

export default UnitPrice;
